import { minify } from 'html-minifier';
import cheerio from 'cheerio';

export default args => new Promise((resolve, reject) => {
  const { raw } = args;
  const minifiedHtml = minify(raw, {
    removeComments: true,
  });
  const $ = cheerio.load(minifiedHtml);
  const generator = $('head > meta[name="generator"]').attr('content');
  if (generator === 'vBulletin 3.8.0') {
    const result = { ...args };
    delete result.raw;
    result.$ = $;
    resolve(result);
  }
  reject(Error('Inappropriate parser'));
});
